
















































































import { Component, Vue } from 'vue-property-decorator';
import { options } from '@/global/region';
import { joinStatus, joinApply } from '@/api/task/team';
import { isLogin } from '../../global/utils';

@Component({})
export default class Login extends Vue {
  private keyword: string = process.env.VUE_APP_KEYWORD;
  private currentStep = 0;
  private regionData = options;
  private status = 1;
  private formItem = {
    title: '',
    style: '',
    name: '',
    mobile: '',
    site: [],
    nums: '',
    reason: '',
  };
  private ruleValidate = {
    title: [{ required: true, message: '请输入团队名称', trigger: 'blur' }],
    style: [{ required: true, message: '请选择团体类型', trigger: 'change' }],
    name: [{ required: true, message: '请输入负责人姓名', trigger: 'blur' }],
    mobile: [
      { required: true, message: '请输入负责人手机号', trigger: 'blur' },
    ],
    site: [
      {
        required: true,
        type: 'array',
        message: '请选择所在地址',
        trigger: 'change',
      },
    ],
    desc: [
      {
        required: true,
        message: 'Please enter a personal introduction',
        trigger: 'blur',
      },
      {
        type: 'string',
        min: 20,
        message: 'Introduce no less than 20 words',
        trigger: 'blur',
      },
    ],
  };
  get userInfo() {
    return this.$store.state.userInfo;
  }
  private created() {
    this.getStatus();
  }
  private async getStatus() {
    if (!isLogin(this)) {
      return;
    }
    const res = await joinStatus();
    this.$nextTick(() => {
      this.status = res.status;
      if (res.status == 1) {
        this.currentStep = 2;
      } else if (res.status == 2) {
        this.currentStep = 1;
        this.formItem = Object.assign(this.formItem, res);
      }
    });
  }
  private handleValidate() {
    (this.$refs.formValidate as any).validate(valid => {
      if (valid) {
        this.handleSubmit();
      } else {
        return false;
      }
    });
  }
  private async handleSubmit() {
    this.$Message.error("创建失败")
  }
}
